import { useRef } from 'react';
import { Button, Portal } from '@nazka/nazka.mapframe.components';
import { faClose } from '@fortawesome/pro-solid-svg-icons';

import { useOnClickOutside } from '@services/hooks.service';

import './registration-confirmation-modal.styl';

function RegistrationConfirmationModal({ onClose }) {
  const contentRef = useRef();

  useOnClickOutside(contentRef, onClose);

  return (
    <Portal>
      <div className="confirmation-modal">
        <div className="confirmation-modal__content" ref={contentRef}>
          <div className="confirmation-modal__content__title">
            <h2>
              Bevestig je emailadres
            </h2>
            <Button
              icon={faClose}
              layout="ghost"
              hover={false}
              className="login-modal__content__header__close"
              onClick={onClose}
            />
          </div>
          <p>
            Je registratie is bijna in orde.
          </p>
          <p>
            We stuurden je een e-mail met een link om je e-mailadres te bevestigen. Klik hierop om je registratie te voltooien.
          </p>
        </div>
      </div>
    </Portal>
  );
}

export default RegistrationConfirmationModal;